import { useState, useEffect } from 'react';

const useInView = ({ threshold = 0.18 }) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold,
    });

    const target = document.querySelector('.fade-in-up'); // You can adjust this class
    if (target) observer.observe(target);

    return () => {
      if (target) observer.unobserve(target);
    };
  }, [threshold]);

  return isInView;
};

export default useInView;
